
/**
 * Validate for valid json
 * @returns {Boolean}
 */
export function isValidJson(json) {
  if (json) {
    try {
      JSON.parse(json);
      return true;
    } catch {
      return false;
    }
  }
  return true;
}